export default __webpack_public_path__ + "static/media/line.efb76a5f.svg";